/**
 * Click-to-jump popup that appears when the user clicks an ICT chart marker.
 * Lets them seek to that timestamp on a different timeframe.
 */
export default function MarkerJumpPopup({ markerPopup, availableTfs, currentTf, main, onClose, onSeek, onSwitchTf }) {
  if (!markerPopup) return null;
  return (
    <div data-testid="marker-popup" className="fixed inset-0 z-40" onClick={onClose}>
      <div
        className="absolute bg-[#0f131b] border border-amber-500/40 rounded-lg shadow-2xl p-2.5 font-mono w-56"
        style={{
          left: Math.min(markerPopup.x + 60, window.innerWidth - 240),
          top: Math.min(markerPopup.y + 80, window.innerHeight - 200),
        }}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-2 pb-1.5 border-b border-slate-800">
          <div className="text-[10px] uppercase font-bold text-amber-300">
            <i className="fa-solid fa-arrows-to-dot mr-1"/>Jump to TF
          </div>
          <button onClick={onClose} className="text-slate-500 hover:text-rose-300 text-[10px]"><i className="fa-solid fa-xmark"/></button>
        </div>
        <div className="text-[10px] text-slate-400 mb-2">
          <div className="text-amber-200 font-bold">{markerPopup.marker?.text || "marker"}</div>
          <div className="text-slate-500">at {new Date((markerPopup.marker?.time || 0) * 1000).toISOString().slice(0,16).replace("T"," ")} UTC</div>
        </div>
        <div className="grid grid-cols-4 gap-1">
          {availableTfs.map(targetTf => (
            <button
              key={targetTf}
              data-testid={`jump-tf-${targetTf}`}
              onClick={() => {
                const t = markerPopup.marker?.time;
                if (targetTf === currentTf) {
                  if (t && main?.length) {
                    let best = 0, bestDiff = Infinity;
                    for (let i = 0; i < main.length; i++) {
                      const d = Math.abs(main[i].time - t);
                      if (d < bestDiff) { bestDiff = d; best = i; }
                    }
                    onSeek(best);
                  }
                } else {
                  onSwitchTf(targetTf, t);
                }
                onClose();
              }}
              disabled={targetTf === currentTf}
              className={`text-[10px] font-bold py-1.5 rounded ${targetTf === currentTf ? "bg-slate-800 text-slate-500 cursor-default" : "bg-amber-500/20 hover:bg-amber-500/40 text-amber-200 border border-amber-500/30"}`}>
              {targetTf}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
